import type { AxiosError } from 'axios'
import { filter, from, mergeMap, of } from 'rxjs'
import { catchError, retryWhen, withLatestFrom } from 'rxjs/operators'
import { serverIsNotAvailable } from '../../../../Framework/Epic/ServerNotAvailable.js'
import { errorMessage } from '../../../../Model/Message/IMessage.js'
import type { Epic } from '../../../index.js'
import { addMessage } from '../../../Slice/Application/ApplicationSlice.js'
import { orderSlice } from '../../../Slice/Order/OrderSlice.js'

export const PullbackOrderEpic: Epic = (action$, state$, { OrderRepository, [orderSlice.name]: order }) =>
  action$.pipe(
    filter(order.pullbackOrderRequest.match),
    withLatestFrom(state$),
    mergeMap(([action, state]) =>
      OrderRepository.pullbackOrder(action.payload, state.authentication.user).pipe(
        mergeMap((response) => {
          return of(order.pullbackOrderSuccess(response))
        }),
        retryWhen(serverIsNotAvailable()),
        catchError((error: AxiosError) => {
          let messages = ['Error pulling back order ' + error?.message]
          const errors = error?.response
          if (errors && Array.isArray(errors) && errors.length > 0) {
            messages = [...messages, ...errors]
          }

          return from(messages).pipe(mergeMap((m) => of(addMessage(errorMessage(m)))))
        })
      )
    )
  )
